import React from "react";
import PropTypes from "prop-types";
import { useFetcher } from "@td/shared_utils";
import { Modal } from "../../emr/components";

export const LabOrderHistoryModal = ({ labOrderId, closeModal }) => {
  const { data, loading, error } = useFetcher(
    `/v4/lab_orders/${labOrderId}/history`
  );

  return (
    <Modal title="Lab Order Timeline" onExit={closeModal}>
      {loading && "Loading ..."}
      {error && "An error occurred"}
      {data && (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Action Taken</th>
              <th>By</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map(item => (
              <tr>
                <td className="date browser_timestamp">{item.timestamp || 'N/A'}</td>
                <td>{item.action}</td>
                <td>{item.actor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal>
  );
};

LabOrderHistoryModal.propTypes = {
  labOrderId: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default { LabOrderHistoryModal };
